export default __webpack_public_path__ + "static/media/refreshDefault.dbcbe792.svg";